<section [attr.id]="sectionId() || null" [class]="'s__dynamic-section' + (background() ? ' s__bg-' + background() : '') + (cssClass() ? ' ' + cssClass() : '')">
  <div class="s__dynamic-section__inner s__container">
    @if (overline()) {
      <ds-overline [text]="overline()" />
    }
    @if (heading()) {
      <h2 class="s__dynamic-section__heading">{{ heading() }}</h2>
    }
    @if (subtitle()) {
      <p class="s__dynamic-section__subtitle" [innerHTML]="subtitle()"></p>
    }
    @for (block of resolvedBlocks(); track block.id) {
      <ng-container *ngComponentOutlet="block.component; inputs: block.inputs" />
    }
    @if (linkText() && linkHref()) {
      <a [attr.href]="linkHref()" class="s__dynamic-section__link">{{ linkText() }}</a>
    }
    <ng-content />
  </div>
</section>
